import { Button, Modal } from "antd";
import axios from "axios";
import { useState } from "react";

import { toast } from "react-toastify";
import TextArea from "antd/es/input/TextArea.js";

export function ModalAdicionarInformacoes({
  formulario,
  isModalAddInformacoesAdicionais,
  setIsModalAddInformacoesAdicionais,
}) {
  const [isLoadingAddInfo, setIsLoadingAddInfo] = useState(false);
  const [infoConteudo, setInfoConteudo] = useState("");

  const adicionarInformacoes = async () => {
    const url = "/portal/rest/contador/cliente/nota/atualizar";
    const info = {
      cliente: {
        id: formulario.clienteId.toString(),
      },
      conteudo: infoConteudo,
      id: formulario.clienteId.toString(),
    };
    setIsLoadingAddInfo(true);
    try {
      const response = await axios.post(url, info, {
        withCredentials: true,
      });

      if (response) {
        toast.success("Informação adicionada com sucesso!");
        setIsModalAddInformacoesAdicionais(false);
      } else {
        toast.error("Erro ao tentar adicionar informações");
      }

    } catch (err) {
      console.warn(err);
    } finally {
      setIsLoadingAddInfo(false);
    }
  };
  return (
    <>
      <Modal
        title="Informações adicionais"
        open={isModalAddInformacoesAdicionais}
        onCancel={() => setIsModalAddInformacoesAdicionais(false)}
        footer={[
          <>
            <div>
              <TextArea
                rows={4}
                placeholder=""
                value={infoConteudo}
                onChange={(e) => setInfoConteudo(e.target.value)}
              />
              <br />
              <br />
              <Button
                style={{ marginRight: "5px" }}
                onClick={() => setInfoConteudo("")}
              >
                Limpar
              </Button>
              <Button
                type="primary"
                onClick={adicionarInformacoes}
                loading={isLoadingAddInfo}
                disabled={isLoadingAddInfo}
              >
                Salvar
              </Button>
            </div>
          </>,
        ]}
      ></Modal>
    </>
  );
}

export default ModalAdicionarInformacoes;
